import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ClientEnum, ClientModel, LanguageModel, SurveySimpleModel, SurveyVersionModel} from '../../../models/survey/survey.model';
import {TypeformService} from './typeform.service';
import {WorkspaceModel} from '../../../models/typeform/workspace.model';
import {FormModel} from '../../../models/typeform/form.model';
import {ToasterService} from 'angular5-toaster/dist';
import {ImportModel} from '../../../models/typeform/import.model';
import {ErrorMessageModel} from '../../../models/typeform/error-message.model';
import {DxAutocompleteComponent} from 'devextreme-angular';
import {UsersService} from '../../users/users.service';
import { SurveyService } from '../surveys.service';
import { ImportFromSystemType } from '../../../shared/constants/input.constants';
import { Observable } from 'rxjs';
import { UserModel } from '../../../models/user/users.model';
import { AuthTokenService } from '../../../shared/services/auth-token.service';
import { isNullOrUndefined } from 'util';
import { PreviousUrlService } from '../../../shared/services/previous-url.service';

@Component({
  selector: 'app-typeform',
  templateUrl: './typeform.component.html',
  styleUrls: ['./typeform.component.less']
})
export class TypeformComponent implements OnInit {
  showLoader: boolean;
  numberOfSurveyImport = 0;
  numberOfSurveyVersionChoosed = 0;
  listFormModel: FormModel[] = [];
  listClientModel: ClientModel[] = [];
  listWorkspaceModel: WorkspaceModel[] = [];
  needImportQuestion = true;
  needImportResponse = true;
  numberMasterQuestion = 0;
  numberMasterResponse = 0;
  masterFormModel: FormModel = null;
  listFormVersion: FormModel[] = [];
  isSelectedAll = false;
  selectedClient: ClientModel = null;
  isDesc = false;
  column = '';
  listLanguageModel: LanguageModel[] = [];
  isValid = false;
  showOverrideSurvey = false;
  showTypeformError = false;
  typeformErrorMessage = '';
  typeformErrorCode = '';
  hasErrorMessage = false;
  errorMessageList: ErrorMessageModel[] = [];
  isMasterSurveyDisable = true;
  importTypeSelected: any;
  listSurveysFilteredByWorkSpace: SurveySimpleModel[];
  existingSurveyMaster: SurveySimpleModel;

  @ViewChild('dxAutoCompleteWorkspace')
  dxAutoCompleteWorkspace: DxAutocompleteComponent;

  listWorkspaceName: string[] = [];
  listLangName: string[] = [];
  listClientName: string[] = [];
  listSurveyName: string[] = [];
  unspecifiedLanguageName = 'English';
  isEnableUnspecifiedLanguage = false;
  listPermission = [
    {value: 'All', text: 'All Users'},
    {value: 'Admin', text: 'Admin Only'},
    {value: 'User', text: 'Selected Users'}
  ];
  listImportType = [
    {value: 'New', text: 'Import as a new survey'},
    {value: 'Add', text: 'Add additional versions to an existing survey'}
  ];
  permissionSelected: any;
  workspaceNameSelected: string;
  listUsers: any[] = [];
  selectedUserIds: number[] = [];

  showTypeformNumberQuestionError = false;
  showTypeformContentQuestionError = false;
  countContentQuestionError = 0;
  errorMessagesApi = [];
  isSkipError = false;
  idSurvey: number;
  currentSurveyMaster: any;
  client: ClientModel;
  currentUser: UserModel;
  isAdmin = AuthTokenService.isAdmin();
  isCustomerAdmin = AuthTokenService.isCustomerAdmin();
  clientDefault: string;
  isTypeFormAuthorization = true;

  constructor(private router: Router,
              private typeformService: TypeformService,
              private toasterService: ToasterService,
              private userService: UsersService,
              private surveyService: SurveyService,
              private shareService: PreviousUrlService,
              private route: ActivatedRoute) 
  {
    this.route.data.subscribe(data => {
        this.client = data.client;
    });
    this.currentUser = AuthTokenService.getUser();
  }

  ngOnInit() {
    if (!this.isAllowImportTypeForm()) {
        this.router.navigate(['surveys']);
    }
    this.shareService.setSurveyTitle('Survey Import');
    this.showLoader = true;
    this.typeformService.getInitData().subscribe(
      res => {
        this.listClientModel = res.clients;
        this.listClientModel = this.listClientModel.filter(f => f.typeFormActivated == true);
        this.listClientModel.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
        this.listClientName = this.listClientModel.map(x => x.name);

        if (this.isAdmin) {
          this.clientDefault =  ClientEnum.INTERNAL;
          this.selectedClient = this.listClientModel.find(x => x.name === this.clientDefault);
        } else {
          this.selectedClient = this.listClientModel.find(x => x.id === this.currentUser.clientId)
          this.clientDefault =  this.selectedClient.name;
        }

        this.listLanguageModel = res.languages.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
        this.listLangName = this.listLanguageModel.map(x => x.name);
        this.showLoader = false;      
        this.importTypeSelected = this.listImportType[0];
      }, err => {
        this.showLoader = false;
      }
      
    );
  }

  cancel() {
    this.router.navigate(['surveys']);
  }

  loadUserByClient(client: ClientModel) {
    if (client && client.id) {
      this.userService.getAllByClient(client.id).subscribe(res => {
        this.listUsers = res.sort((a, b) => `${a.firstName} ${a.lastName}`.toLowerCase() > `${b.firstName} ${b.lastName}`.toLowerCase() ? 1 : -1);
      });
    }
  }

  import(override = false) {
    if (!this.selectedClient) {
      this.toasterService.pop('error', 'Please select a client to import');
      return;
    }

    if (!this.masterFormModel) {
      this.toasterService.pop('error', 'Please select a master survey to import');
      return;
    }

    if (this.listFormVersion.filter(f => f.isChecked && !f.languageId).length) {
      this.toasterService.pop('error', 'Please select language for all survey version that you select them to import');
      return;
    }

    this.showOverrideSurvey = false;
    this.showTypeformError = false;
    this.showLoader = true;

    const importModel = new ImportModel();
    importModel.clientId = this.selectedClient.id;
    importModel.importQuestion = this.needImportQuestion;
    importModel.importResponse = this.needImportResponse;
    importModel.masterId = this.masterFormModel.id;
    importModel.override = override;
    importModel.isSkipValidate = this.isSkipError;
    importModel.workspaceName = this.workspaceNameSelected;
    const listVersion: any[] = [];
    this.listFormVersion.filter(f => f.isChecked && !f.existVersion).forEach(f => {
      listVersion.push({Id: f.id, LanguageId: f.languageId});
    });
    importModel.listVersion = listVersion;
    importModel.permission = this.permissionSelected.value;
    importModel.userIds = this.selectedUserIds;

    this.hasErrorMessage = false;
    this.errorMessageList = [];
    let importSurveyObservable: Observable<any>;
    
    if (this.importTypeSelected.value =="Add") {      
      importModel.surveyId = this.existingSurveyMaster.id;
      importSurveyObservable = this.typeformService.ImportExistingSurvey(importModel);
    } else {     
      importSurveyObservable = this.typeformService.importSurvey(importModel); 
    }

    importSurveyObservable.subscribe(
      res => {
        const success = res.success;
        this.showLoader = false;
        if (success) {
          this.toasterService.pop('success', 'Import complete');
          this.router.navigate(['surveys']);
        } else {
          this.isSkipError = false;
          const error: string = res.error;
          if (error === 'duplicate_survey') {
            this.showOverrideSurvey = true;
            this.isSkipError = true;
          } else if (error === 'validate_survey') {
            this.errorMessagesApi = res.messages;
            this.controlImportErrorDialog();
            this.showPanelErrorMessage(res.messages);
          }
        }
      }, err => {
        this.showLoader = false;
        const message = err.message;
        if (message && message.indexOf('typeform_error') === 0) {
          this.showTypeformError = true;
          this.typeformErrorCode = message.split(';')[1];
          this.typeformErrorMessage = message.split(';')[2];
        } else {
          this.toasterService.pop('error', 'Something went wrong');
        }
      }
    );
  }

  controlImportErrorDialog(isSkipNumberQuestionError = false, isSkipContentError = false) {
    if(this.isNumberQuestionError(this.errorMessagesApi) && !isSkipNumberQuestionError) {
      this.showTypeformNumberQuestionError = true;
    }
    else {
      const numberContentError = this.getNumberContentQuestionError(this.errorMessagesApi);
      if (numberContentError && !isSkipContentError) {
        this.countContentQuestionError = numberContentError;
        this.showTypeformContentQuestionError = true;
      } else {
        this.isSkipError = true;
        this.import();
      }
    }
  }

  showPanelErrorMessage(listErrorDisplay: any) {
    this.hasErrorMessage = true;
    this.errorMessageList = listErrorDisplay ? listErrorDisplay.filter(item => item.errorType !== "NumberQuestion" ) : [];
  }

  getNumberContentQuestionError(listError: any) {
    return listError.filter(item => item.errorType === "QuestionContent").length;
  }

  isNumberQuestionError(listError: any) {
    return listError.filter(item => item.errorType === "NumberQuestion").length > 0;
  }

  onFilterChange(event: any, s: FormModel) {
    s.isChecked = !s.isChecked;
    this.calculateNumberOfSurveyImport();
    this.checkValidForm();
  }

  calculateNumberOfSurveyImport() {
    this.isEnableUnspecifiedLanguage = this.masterFormModel
      && this.listFormVersion.filter(x => x.isChecked && !x.languageId).length > 0;
    this.numberOfSurveyImport = this.listFormVersion.filter(f => f.isChecked && !f.existVersion).length + (this.masterFormModel && this.importTypeSelected.value !="Add" ? 1 : 0);
    this.numberOfSurveyVersionChoosed = this.listFormVersion.filter(f => f.isChecked).length;
    const numberOfSurveyVersionEnabled = this.listFormVersion.filter(f => f.isEnabled).length;
    this.isSelectedAll = numberOfSurveyVersionEnabled > 0 && this.numberOfSurveyVersionChoosed === numberOfSurveyVersionEnabled;
  }

  sort(by: string) {
    this.isDesc = !this.isDesc;
    this.column = by;
    const direction = this.isDesc ? 1 : -1;

    this.listFormVersion.sort(function (a, b) {
      return a[by] < b[by] ? -1 * direction : direction;
    });
  }

  selectAllSurveyVersion(e: any) {
    this.listFormVersion.filter(f => f.isEnabled).forEach(f => f.isChecked = e);
    this.calculateNumberOfSurveyImport();
    this.checkValidForm();
  }

  onSelectedMasterSurvey(event: any) {
    const surveyName = event.value;
    this.changeMasterSurvey(this.listFormModel.find(x => x.title === surveyName));
  }

  onSelectedClient(event: any) {
    const clientName = event.value;
    this.selectedClient = this.listClientModel.find(x => x.name === clientName);
    this.getSurveysByWorkSpace();
    this.checkValidForm();
    this.checkTypeFormAuthorization();
    this.loadUserByClient(this.selectedClient);
  }

  onSelectedLanguage(e: any, form: FormModel) {
    const langName = e.value;
    let language = this.listLanguageModel.find(x => x.name === langName);
    if (language) {
      form.languageId = language.id;      
    }
    this.checkValidForm();
  }

  onSelectedUnspecifiedLanguage(e: any) {
    this.unspecifiedLanguageName = e.value;
  }

  onGoClicked() {
    const languageId = this.listLanguageModel.find(x => x.name === this.unspecifiedLanguageName).id;
    this.listFormModel.filter(x => !x.languageId && x.isChecked).forEach(x => x.languageId = languageId);
  }

  onImportQuestionChange(event: any) {
    this.needImportQuestion = !this.needImportQuestion;
    if (!this.needImportQuestion) {
      this.needImportResponse = false;
    }
  }

  onImportResponseChange(event: any) {
    this.needImportResponse = !this.needImportResponse;
  }

  getLanguageName(id: number): string {
    if (id !== null) {
      return this.listLanguageModel.find(la => la.id === id).name;
    }
  }

  private checkValidForm() {
    
    this.isEnableUnspecifiedLanguage = this.masterFormModel
      && this.listFormVersion.filter(x => x.isChecked && !x.languageId).length > 0;
    
      if (this.selectedClient && this.masterFormModel && this.permissionSelected) {
      if (this.permissionSelected.value === 'User' && this.selectedUserIds.length === 0) {
        this.isValid = false;
        return;
      } else {
        
        if (this.importTypeSelected.value =="Add") {   
          let quantitySelected = this.listFormVersion.filter(f => (f.isChecked && !f.existVersion  ) ).length;            
            if (quantitySelected > 0) {              
              this.isValid = !(this.listFormVersion.filter(f => (f.isChecked && !f.existVersion && !f.languageId  ) ).length > 0) ;
            } else {
              this.isValid = false;
            }            
        } else {          
          this.isValid = !(this.listFormVersion.filter(f => f.isChecked && !f.languageId).length > 0);
        }
        return;
      }
    }
    this.isValid = false;
  }

  changeMasterSurvey(e) {
    if (e) {
      this.numberMasterQuestion = e.numberQuestion;
      this.numberMasterResponse = e.numberResponse;
      this.masterFormModel = e;
      this.listFormVersion = this.listFormModel.filter(f => f.id !== this.masterFormModel.id);
      this.listFormVersion.forEach(f => {
          f.isChecked = true;
          f.isEnabled = true;
          if (f.numberQuestion < this.masterFormModel.numberQuestion) {
            f.isLowerNumberQuestion = true;
          } else {
            f.isLowerNumberQuestion = false;
          }
      });
      this.checkValidForm();
      this.calculateNumberOfSurveyImport();
    }
  }

  
  changeMasterExistentSurvey(e) {
    if (e) {
      this.numberMasterQuestion = e.numberQuestion;
      this.numberMasterResponse = e.numberResponse;
      this.masterFormModel = e;
      this.listFormVersion = this.listFormModel.filter(f => f.id !== this.masterFormModel.id);
      this.listFormVersion.forEach(f => {
          if (f.numberQuestion < this.masterFormModel.numberQuestion) {
            f.isLowerNumberQuestion = true;
          } else {
            f.isLowerNumberQuestion = false;
          }
      });
      this.checkValidForm();
      this.calculateNumberOfSurveyImport();
    }
  }

  onWorkspaceChanged(event: any) {
    this.isMasterSurveyDisable = false;
    this.workspaceNameSelected = event.value;
    const workspace = this.listWorkspaceModel.find(x => x.name === this.workspaceNameSelected);
    if (!isNullOrUndefined(workspace)) {
        const workspaceId = workspace.id;
        this.idSurvey = 0;
        this.showLoader = true;
        this.typeformService.getWorkspaceInfo(workspaceId, this.selectedClient.id).subscribe(
        res => {
            this.listFormModel = res.items;
            this.listFormModel.forEach(f => {
            if (!f.existVersion) {      
                f.isChecked = true;
                f.isEnabled = true;       
            } else { 
                f.isChecked = true;
                f.isEnabled = false;
            }
            });
            this.listFormModel.sort((a, b) => a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1);
            this.listSurveyName = this.listFormModel.map(x => x.title);
            this.listFormVersion = this.listFormModel;
            this.numberOfSurveyImport = 0;
            this.numberMasterQuestion = 0;
            this.numberMasterResponse = 0;
            
            if (this.importTypeSelected.value === 'Add') {
            this.getSurveysByWorkSpace();
            } else {          
            this.showLoader = false;
            }
            this.calculateNumberOfSurveyImport();
        }, err => {
            this.showLoader = false;
            this.masterFormModel = null;
        }
      );
    }
  }

  onSelectedPermission(event: any) {
    if (event.value !== this.permissionSelected) {
      this.selectedUserIds = [];
    }
    this.permissionSelected = event.value;
    this.checkValidForm();
  }

  onSurveyLocalChange(event: any){
    this.existingSurveyMaster = event.value;
    this.idSurvey = this.existingSurveyMaster.id;
    this.masterFormModel =  this.listFormModel.find(f => f.title === this.existingSurveyMaster.name);
    if (this.masterFormModel) {      
      this.masterFormModel.isMaster = true;        
      this.changeMasterExistentSurvey(this.masterFormModel);
    } else {      
      this.toasterService.pop('error', 'Master survey no found ');
    }

    this.surveyService.getSurveyVersionLanguage(this.idSurvey).subscribe(response=>{
      let surveyVersionLanguage: SurveyVersionModel[] = response;
      this.listFormModel.forEach(form => {
        let surveyVersionFound = surveyVersionLanguage.find(s=>s.nameVersion === form.title);

        if(surveyVersionFound){
          form.existVersion = true;
          form.isChecked = true;
          form.isEnabled = false;
          form.languageId = surveyVersionFound.languajeID;
        } else {
          form.existVersion = false;
          form.isChecked = true;
          form.isEnabled = true;
          form.languageId = null;
        }
      });
    });
  // this.onWorkspaceChanged(data);
  }

  onImportTypeChanged(event: any) {
    this.importTypeSelected = event;
    if (event.value === 'Add') {      
      this.getSurveysByWorkSpace();
      this.listFormVersion.forEach(f => f.isLowerNumberQuestion = false);
    } else {
      this.masterFormModel = null;
      this.listFormModel.forEach(form => {
         form.existVersion = false;
          form.isChecked = false;
          form.isEnabled = true;
          form.languageId = null;

      });
    }
  }

  getSurveysByWorkSpace() {
    if (!isNullOrUndefined(this.selectedClient)) {
      this.showLoader = true;
      this.surveyService.getSurveysByWorkSpaceName(this.workspaceNameSelected, ImportFromSystemType.TypeForm, this.selectedClient.id).subscribe(response=>{
        if (response) {
          this.listSurveysFilteredByWorkSpace = response; 
          
          if (this.listSurveysFilteredByWorkSpace && this.listSurveysFilteredByWorkSpace.length === 1) {   
            this.existingSurveyMaster = this.listSurveysFilteredByWorkSpace[0];
          }
        }      
      }, err=>{ },
      ()=> {
        this.showLoader = false; 
        this.masterFormModel = null;
        this.checkValidForm();
      });
    }
  }

  getWorkspace() {
    this.showLoader = true;
    this.typeformService.getWorkspace(this.selectedClient.id).subscribe(res=>{
        this.listWorkspaceModel = res;
        this.listWorkspaceModel.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
        this.listWorkspaceName = this.listWorkspaceModel.map(x => x.name);
        this.showLoader = false;
    });
  }

  displayPermission(p) {
    return p ? p.text : null;
  }

  onSelectedUsers(event) {
    this.selectedUserIds = event;
    this.checkValidForm();
  }

  displayExpr(s) {
    return `${s.firstName} ${s.lastName}`;
  }

  goToSurveyMonkey() {
    this.router.navigate(['surveys/import-survey-monkey']);
  }

  goToImportCSV() {
    this.router.navigate(['surveys/import-csv']);
  }

  isAllowImportTypeForm(): boolean {
    return this.isAdmin || (this.isCustomerAdmin && (this.currentUser.allowImportTypeForm && this.client.typeFormActivated));
  }

  isAllowImportSurveyMonkey(): boolean {
    return this.isAdmin || (this.isCustomerAdmin && (this.currentUser.allowImportSurveyMonkey && this.client.surveyMonkeyActivated));
  }

  isAllowImportCSV(): boolean {
    return this.isAdmin || (this.isCustomerAdmin && (this.currentUser.allowImportCSV));
  }

  checkTypeFormAuthorization() {
    this.listWorkspaceName = [];
    this.workspaceNameSelected = null;    
    if (!isNullOrUndefined(this.selectedClient)) {
      this.showLoader = true;
      setTimeout(() => {
          this.typeformService.isTypeFormAuthorization(this.selectedClient.id).subscribe(res => {
              this.isTypeFormAuthorization = res;
              if (this.isTypeFormAuthorization) {
                  this.getWorkspace();
              }
              this.showLoader = false;
          })
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/typeform/typeform.component.ts